import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
var __default__ = {
  name: "StaffsIndex",
  data: function data() {
    return {
      isLoading: {
        staffs: true
      },
      filterKeyword: "",
      staffs: [],
      // API からとってきたオリジナルデータ
      visibleStaffs: [] // 加工表示用
    };
  },
  head: {
    title: {
      inner: "職員一覧"
    },
    meta: []
  },
  created: function created() {
    this.setData();
  },
  methods: {
    setData: function setData() {
      var _this = this;
      getData("staffs").then(function (data) {
        _this.staffs = _this.visibleStaffs = data.items;
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this.isLoading.staffs = false;
      });
    },
    filterData: function filterData(e) {
      e.preventDefault();
      var staffs = this.staffs;
      var keyword = this.filterKeyword;
      if (keyword) {
        staffs = staffs.filter(function (v) {
          return Object.keys(v).some(function (k) {
            return String(v[k]).indexOf(keyword) > -1;
          });
        });
      }
      this.visibleStaffs = staffs;
    }
  }
};
import { inject } from "vue";
import { getData } from "@/services/axios";

import { meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    // @ts-check
    var me = inject(meKey);
    return {
      __sfc: true,
      me: me
    };
  }
});